export default __webpack_public_path__ + "static/media/alert2.b1ebe877.svg";